import en from './en.js'
import zh from './zh.js'

export const LANGUAGE_STORAGE_KEY = 'wechatai_language'
export const DEFAULT_LANGUAGE = 'zh'
export const SUPPORTED_LANGUAGES = ['zh', 'en']

export const dictionaries = {
  en,
  zh,
}

export function normalizeLanguage(value) {
  return SUPPORTED_LANGUAGES.includes(value) ? value : DEFAULT_LANGUAGE
}

function readPath(source, key) {
  return String(key)
    .split('.')
    .reduce((current, part) => (
      current && Object.prototype.hasOwnProperty.call(current, part)
        ? current[part]
        : undefined
    ), source)
}

export function translate(language, key, params = {}) {
  const normalizedLanguage = normalizeLanguage(language)
  const value = readPath(dictionaries[normalizedLanguage], key)
    ?? readPath(dictionaries[DEFAULT_LANGUAGE], key)
    ?? key
  if (typeof value !== 'string') return key
  return value.replace(/\{\{(\w+)\}\}/g, (_, name) => (
    params[name] === undefined || params[name] === null ? '' : String(params[name])
  ))
}
